import remainingChars from "./_remaining-chars";

export default function () {
    remainingChars.initOnce();
}